module.exports = __webpack_public_path__ + "static/img/quality_en.dadbc69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quality_en.jpg
// module id = PhYs
// module chunks = 1